module.exports = __webpack_public_path__ + "static/media/win-reward-A09.9c7064b0.png";